import { defineStore } from "pinia";
// import axios from "axios";
// import api from "@/api";
// import { API_BASE_URL } from "@/global-constants";
import { useMasterDataStore } from "./MasterDataStore";
export const usePenggajianStatusStore = defineStore("penggajianStatusStore", {
  state: () => ({
    data: null,
  }),
  getters: {
    filter() {
      return this.data.filter((g) => g.nama);
    },
  },
  actions: {
    async get() {
      // Fetch data only if it hasn't been fetched before

      // if (!this.data) {
      //   try {
      //     const config = {
      //       headers: {
      //         Authorization: api.defaults.headers.common["Authorization"],
      //         "content-type": "application/json",
      //       },
      //     };
      //     var res = await axios.get(`${API_BASE_URL}/gajiStatus`, config);
      //     this.data = res.data;
      //   } catch (error) {
      //     console.error('penggajianStatusStore Error fetching:', error);
      //   }
      // }

      if (!this.data) {
        const master = useMasterDataStore();
        const masterData = await master.get();

        this.data = masterData.penggajianStatus || [];
      }

      return this.data;
    },
    // reset(){
    //     console.log("penggajianStatusStore clear")
    //     this.data = null;

    // }
    async reset() {
      // Add async
      this.data = null; // Clear the store

      const newData = await this.get(); // Fetch new data

      this.data = newData; // Store the fetched data
      return this.data; // Ensure reset() returns the data
    },
  },
  onInit() {
    this.get();
  },
  persist: true,
  onBeforeMount() {
    this.get();
  },
});
